import { useNavigation } from "@react-navigation/native";
import { AHText, Box, TouchableBox } from "arkh";
import { FormattedMessage } from "react-intl";
import { Platform } from "react-native";

export function IntegrationHeader(props: {
  logo: React.ReactNode;
  description?: React.ReactNode;
  button?: React.ReactNode;
}) {
  return (
    <Box
      color="surface"
      style={{ borderBottomWidth: 1 }}
      borderColor="border-primary"
      spaceVertical="large"
    >
      <Box spaceHorizontal="large" style={{ height: 40 }}>
        {props.logo}
      </Box>
      <Box spaceHorizontal="large" spaceTop="medium">
        {props.description}
      </Box>
      <Box
        spaceHorizontal="large"
        spaceTop="medium"
        style={{ flexDirection: "row" }}
      >
        {props.button}
      </Box>
    </Box>
  );
}
export function IntegrationHeaderLink(props: {
  link: string;
  children?: React.ReactNode;
}) {
  const navigation = useNavigation();
  return (
    <TouchableBox
      spaceVertical="small"
      spaceHorizontal="medium"
      borderColor="border-primary"
      cornerRadius="medium"
      style={{ borderWidth: 1 }}
      color="surface-background-light"
      onPress={() => {
        if (Platform.OS === "web") {
          window.open(props.link, "_blank");
        } else {
          (navigation as any).navigateDeprecated("WebView", {
            url: props.link,
          } as any);
        }
      }}
    >
      <AHText type="info-small" color="text-secondary">
        {props.children ?? (
          <FormattedMessage
            description="IntegrationsAdminIntegrationHeaderLink"
            defaultMessage="Read more"
          />
        )}
      </AHText>
    </TouchableBox>
  );
}

IntegrationHeader.Link = IntegrationHeaderLink;
